import React, { useContext, useEffect, useState } from "react"
import { Urls } from "../../../../../Urls"
import axios from "../../../../../Axios/Axios"
import Loader from "../../../../Loader"
import { saveMastersApi } from "../../../Utility"
import { toast } from "react-toastify"
// import { CompanyProfileApiContext } from "../../../../../Context/CompanyProfileContext"
import { UserApiContext } from "../../../../UserDetailsContext/UserDetailsContext"
import { MyCompanyProfileContext } from "../../../../../MyCompanyProfileContext"
import { useMixPanelForTracking } from "../../../../../utils/TrackMixPanel"

/**
 * Step 2 Location Review step for multi hop
 * Component for displaying and reviewing location details in step2 for multi hop.
 * 
 * @param {number} step - current step
 * @param {React.SetStateAction} setStep - sets the current step
 * @param {Array<Object>} uploadedData - Array of uploaded route data
 * @param {React.SetStateAction} setUploadedData - setter to update the uploaded data
 * @param {Array<Object>} routeMasterList - List of master routes
 * @param {React.SetStateAction} setRouteMasterList - setter to update the master route list
 * @param {React.SetStateAction} setAdded_list - setter to the add new routes
 * @param {Array} added_list - Array with new added routes
 * @returns {JSX.Element} rendered LocationDetails component
 */
const RouteMultiHopDetails = ({ step = 2, setStep = '', uploadedData, setUploadedData, routeMasterList, setRouteMasterList, setAdded_list, added_list,selectedOrg="company"}) => {

    const [uploaded_data, setUploaded_data] = useState([])
    const [origin_suggestion, setOrigin_suggestion] = useState([])
    const [destination_suggestion, setDestination_suggestion] = useState([])
    const [show, setshow] = useState(false)
    const [multi_hop_data, setMulti_hop_data] = useState([])
    const {companyProfile, userDetails} = useContext(UserApiContext)
    const { companySettingData } = useContext(MyCompanyProfileContext)
    const { TrackMixPanel } = useMixPanelForTracking(userDetails, companySettingData)
    const [company_id, setcompany_id] = useState('')

    // useeffect to fetch suggestions of uploaded lanes
    useEffect(async() => {
        setshow(true)
        if (uploadedData && uploadedData.length > 0) {
            
            // set uploaded data
            setUploaded_data(uploadedData)
            var originList = []
            var destinationList = []
            var list1 = []
            var temp = uploadedData

            // set mutli hop routes
            temp.map((data) => {
                if(data['Route Type*'] === 'multi_hop'){
                    list1.push(data)
                    return data
                } 
            }) 
            setMulti_hop_data(list1)

            // map all origins for payload
            temp.map((data) => {
                if(data['Route Type*'] === 'multi_hop'){
                    var list = {
                        "raw_location": data['Origin*'],
                        "raw_district": data['Origin District'] ? data['Origin District'] : '',
                        "raw_state": data['Origin State*']
                    }
                    return originList.push(list)
                }
            })

            // map all destinations
            temp.map((data) => {
                if(data['Route Type*'] === 'multi_hop'){
                    var list = {
                        "raw_location": data['Destination*'],
                        "raw_district": data['Destination District'] ? data['Destination District'] : '',
                        "raw_state": data['Destination State*']
                    }
                    return destinationList.push(list)
                }
            })
            var origin_payload = {
                "location_list": originList
            }
            var destination_payload = {
                "location_list": destinationList
            }

            // fetch suggestions for origin and destination
            axios.post(`${Urls.Autocomplete.Post.bulkSuggestion}?bulk_suggestions=true`, origin_payload)
                .then((res) => {
                    // setshow(false)
                    setOrigin_suggestion(res.data)
                })
                .catch((error) => {
                    console.log(error)
                    // setshow(false)
                })
            await axios.post(`${Urls.Autocomplete.Post.bulkSuggestion}?bulk_suggestions=true`, destination_payload)
                .then((res) => {
                    setDestination_suggestion(res.data)
                    setshow(false)
                })
                .catch((error) => {
                    console.log(error)
                    setshow(false)
                })
        }
    }, [uploadedData])

    // set company id from company profile context
    useEffect(() => {
        setshow(true)
        if (companyProfile) {
            if (companyProfile.domain_data && companyProfile.domain_data.company_id) {
                var id = companyProfile.domain_data.company_id
                setcompany_id(id)
            }
        }
    }, [companyProfile])

    /**
     * Function to match location to suggestion
     * @param {string} index - index of location
     * @param {Array<Object>} details -  details of location
     * @param {string} id - location identifier
     * @returns {void} does not return anything
     * 
     * Todo - Replace this index matching to location name or code 
     */
    const default_location_name = (index, details, id) => {
        if (id === 'origin') {
            var origin
            origin_suggestion.map((suggestion, idx) => {
                if (index === idx) {
                    origin = suggestion.value[0]
                }
            })
            return origin
        }
        else {
            var destination
            destination_suggestion.map((suggestion, idx) => {
                if (index === idx) {
                    destination = suggestion.value[0]
                }
            })
            return destination
        }
    }

    /**
     * Saves the location details and updates the Location data state.
     * @param {Array<Object>} other_details - Array of location details to be saved
     */
    const save_details = () => {
        var multiHop = multi_hop_data.map((details, index) => {
            if(details['Route Type*'] === 'multi_hop'){
                var temp = {
                    "origin": details.origin ? details.origin : default_location_name(index, details, 'origin'),
                    "destination": details.destination ? details.destination : default_location_name(index, details, 'destination'),
                    "route_type": details['Route Type*'] ? details['Route Type*'] : 'multi_hop',
                    "distance": details['Distance'] ? details['Distance'] : "",
                    "duration": details['Duration'] ? details['Duration'] : "",
                    "spot_route": details['Spot Route'] ? JSON.parse(details['Spot Route']) : false,
                    "route_code": details['Route Code*'],
                    "no_of_hops": details['No of hops'] ? details['No of hops'] : "",
                    "sort_order": details['Sort Order'] ? details['Sort Order'] : "",
                }
                return temp
            }
        })
        var new_list = added_list.concat(multiHop)
        var route_master = new_list.map((list) => {
            return {
                "origin": list.origin,
                "destination": list.destination,
                "route_type": list.route_type,
                "distance": list.distance ? list.distance : '',
                "duration": list.duration ? list.duration : '',
                "spot_route": list.spot_route ? list.spot_route : false,
                "route_code": list.route_code,
                "no_of_hops": list.no_of_hops ? list.no_of_hops : '',
                "sort_order": list.sort_order ? list.sort_order : '',
            }
        })
        TrackMixPanel({
            moduleName: 'masters',
            screenName: 'masters - other masters - route master',
            data: 'none',
            definition: 'route master details review screen: user clicked on confirm and save button',
        });
        // console.log(route_master, 'if route_master')
        saveMastersApi(company_id, 'route', route_master,selectedOrg, TrackMixPanel)
            .then(res => {
                setshow(false)
                if (res.data.status === false) {
                    if (res.data.message.includes("already exist in Route Master")) {
                        const codes = res.data.error_codes?.join(", ") || "";
                        toast.error(`Duplicate route(s): ${codes}. Use a different origin & destination or update the existing route.`);
                    } else {
                        toast.error(res.data.message || "Failed to save route master");
                    }
                    return;
                }
                toast.success("Data submitted successfully")
            })
            .catch(err => {
                setshow(false)
                console.log(err)
            })
    }

    
    /**
     * finds default origin from suggestion
     * @param {Event} e - Event for selection
     * @param {String} index - index of route
     * @param {Array<Object>} data - array for all input data
     * @returns {void} does not return anything
     */
    const originSelection = (e, index, data) => {
        origin_suggestion.map((suggestion, idx) => {
            if (idx === index) {
                suggestion.value.map((location, i) => {
                    if (location.location_name === e) {
                        data.origin = location
                    }
                })
            }
        })
    }

   /**
     * finds default destination from suggestion
     * @param {Event} e - Event for selection
     * @param {String} index - index of route
     * @param {Array<Object>} data - array for all input data
     * @returns {void} does not return anything
     */
    const destinationSelection = (e, index, data) => {
        destination_suggestion.map((suggestion, idx) => {
            if (idx === index) {
                suggestion.value.map((location, i) => {
                    if (location.location_name === e) {
                        data.destination = location
                    }
                })
            }
        })
    }

    return (
        <>
            <div className={`mt-4`} style={{height: '48vh', overflowY: 'auto'}}>
                <Loader show={show} />
                <table className={`table table-borderless`}>
                    <thead>
                        <tr style={{ fontSize: "14px", opacity: "0.7" }}>
                            <th scope="col" style={{ textAlign: "center" }}>Sr No.</th>
                            <th scope='col' style={{ textAlign: "center", width: '10%' }}>Origin</th>
                            <th scope="col" style={{ textAlign: "center" }}>Cleaned Origin</th>
                            <th scope="col" style={{ textAlign: "center" }}>Destination</th>
                            <th scope='col' style={{ textAlign: "center" }}>Cleaned Destination</th>
                        </tr>
                    </thead>
                    <tbody>
                        {multi_hop_data && multi_hop_data.length > 0 ?
                            multi_hop_data.map((data, index) => {
                                if (data['Route Type*'] === 'multi_hop') {
                                    return <tr>
                                        <td style={{ textAlign: "center" }}>
                                            {index + 1}.
                                        </td>
                                        <td style={{ textAlign: "center" }}>
                                            {data['Origin*']}
                                        </td>
                                        <td style={{ textAlign: "center" }}>
                                        <select id="contract_tenure"
                                            // value={selected_option}
                                            className={`form-control`}
                                            onChange={e => originSelection(e.target.value, index, data)}
                                        >
                                            {origin_suggestion && origin_suggestion.length > 0 ?
                                                origin_suggestion.map((suggestion, key) => {
                                                    if (index === key) {
                                                        return suggestion.value.map((location, idx) => (
                                                            <option key={`${idx}`} value={`${location.location_name}`}>
                                                                {location.location_name}
                                                            </option>
                                                        ));
                                                    }
                                                    return null
                                                })
                                                : []}
                                        </select>
                                        </td>
                                        <td style={{ textAlign: "center" }}>
                                            {data['Destination*']}
                                        </td>
                                        <td style={{ textAlign: "center" }}>
                                            <select id="contract_tenure"
                                                // value={selected_option}
                                                className={`form-control`}
                                                onChange={e => destinationSelection(e.target.value, index, data)}
                                            >
                                                {destination_suggestion && destination_suggestion.length > 0 ?
                                                    destination_suggestion.map((suggestion, key) => {
                                                        if (index === key) {
                                                            return suggestion.value.map((location, idx) => (
                                                                <option key={`${idx}`} value={`${location.location_name}`}>
                                                                    {location.location_name}
                                                                </option>
                                                            ));
                                                        }
                                                        return null
                                                    })
                                                    : []}
                                            </select>
                                        </td>
                                    </tr>
                                }
                            })
                            : null}
                    </tbody>
                </table>

            </div>
            <div className='text-center mt-3'>
                <button className='btn btn-success mr-5' onClick={() => save_details(uploaded_data)}>Confirm and Save</button>
            </div>
        </>
    )
}

export default RouteMultiHopDetails